import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map, mapTo } from 'rxjs/operators';
import { PersonApi, SchoolApi } from '../+api';
import { SchoolBillingAddressInterface } from '../+models';
import { SchoolBillingAddressServiceInterface } from './school-billing-address.service.interface';

@Injectable({
  providedIn: 'root',
})
export class SchoolBillingAddressService implements SchoolBillingAddressServiceInterface {
  constructor(private schoolApi: SchoolApi, private personApi: PersonApi) {}

  getAllForUser(userId: number): Observable<SchoolBillingAddressInterface[]> {
    return this.personApi
      .getData(userId, 'schoolBillings')
      .pipe(map((res: { schoolBillings: SchoolBillingAddressInterface[] }) => res.schoolBillings));
  }

  createSchoolBillingAddressForSchool(
    schoolId: number,
    schoolBillingAddress: SchoolBillingAddressInterface
  ): Observable<SchoolBillingAddressInterface> {
    return this.schoolApi.createSchoolBillingAddress(
      schoolId,
      schoolBillingAddress
    ) as Observable<SchoolBillingAddressInterface>;
  }

  updateSchoolBillingAddressForSchool(
    schoolId: number,
    schoolBillingAddressId: number,
    update: Partial<SchoolBillingAddressInterface>
  ): Observable<SchoolBillingAddressInterface> {
    return this.schoolApi.updateSchoolBillingAddress(
      schoolId,
      schoolBillingAddressId,
      update
    ) as Observable<SchoolBillingAddressInterface>;
  }

  deleteSchoolBillingAddressForSchool(schoolId: number, schoolBillingAddressId: number): Observable<boolean> {
    return this.schoolApi.deleteSchoolBillingAddress(schoolId, schoolBillingAddressId).pipe(mapTo(true));
  }
}
